import { PREDEFINED_USER_ROLES, ROLE_PERMISSIONS } from '../../../common/constants';
import { getUserName } from '../../../common/utils/user/getUserName';
import { isExtraAccessActive } from '../../../common/utils/user/extraAccess';
import { MY_DAY_MODE } from './useMyDayMode';

/**
 * Employee previews are an AVC admin training tool. The service-run query
 * remains the authority for state, route and manager scope.
 * Returns { canViewEmployeeDays, canEngageEmployeeRuns }.
 */
export const getEmployeeDayAccess = ({ canAccessMyDayFeature, isAVC, user, hasPermission }) => {
	const canViewEmployeeDays = Boolean(canAccessMyDayFeature && isAVC &&
		(user?.isSuperAdmin || user?.role?.name === PREDEFINED_USER_ROLES.ADMIN) &&
		hasPermission(ROLE_PERMISSIONS.VIEW_SERVICE_RUN_LIST_PAGE));
	const canEngageEmployeeRuns = Boolean(canViewEmployeeDays &&
		hasPermission(ROLE_PERMISSIONS.ADD_EDIT_SERVICE_RUNS) &&
		hasPermission(ROLE_PERMISSIONS.ADD_EDIT_PICK_LISTS));

	return { canViewEmployeeDays, canEngageEmployeeRuns };
};

// Extra access lets a driver help with picking (e.g. after their run) while keeping their own role,
// so My day can show the picking screen until the extra access ends.
export const canShowPickingWorkForMode = ({ user, hasPermission, mode }) => Boolean(isExtraAccessActive(user?.extraAccess) &&
	hasPermission(ROLE_PERMISSIONS.ADD_EDIT_PICK_LISTS) &&
	[MY_DAY_MODE.DRIVER, MY_DAY_MODE.HUB].includes(mode));

// Training context for an admin working an employee's run (see myDayTraining.js);
// null when the run is not one of the selected employee's runs.
export const buildEmployeeTrainingContext = ({ employee, runId, scopeKey }) => {
	if (!employee?.id || !employee?.runIds?.includes(String(runId))) {
		return null;
	}

	const resolvedName = getUserName(employee);
	return {
		runId: String(runId),
		runIds: employee.runIds.map(String),
		targetDriverId: String(employee.id),
		targetDriverName: ['No user', 'Un-named user'].includes(resolvedName)
			? employee.username || 'the assigned driver'
			: resolvedName,
		dateKey: employee.dateKey,
		scopeKey,
	};
};
